// Next Diamonds - PDP Sale Pill
// - Live countdown using data-sale-end (ISO datetime). Auto-hides when expired.
// - Recalculates discount % on variant change (Symmetry fires on:variant:change).
// - Shows "Ends soon" when no end time set (handled by Liquid; this script does nothing extra).

(function () {
  'use strict';

  // When this much time or less remains, switch from "ENDS SOON" label to
  // the live countdown timer. Matches collection-sale-banner.js + pdp-sale-banner.js.
  var TIMER_THRESHOLD_MS = 48 * 60 * 60 * 1000; // 48 hours

  var pill = document.querySelector('[data-nd-pill]');
  if (!pill) return;

  var saleEnd = pill.getAttribute('data-sale-end');
  var endTime = saleEnd ? new Date(saleEnd).getTime() : 0;

  // Mode-switching elements (added in pdp-sale-pill.liquid when _sale_end is set).
  var endsSoonEl = pill.querySelector('[data-nd-pill-ends-soon]');
  var labelEl    = pill.querySelector('[data-nd-pill-label]');
  var timerEl    = pill.querySelector('[data-nd-pill-timer]');

  function setMode(showTimer) {
    if (endsSoonEl) endsSoonEl.hidden = showTimer;
    if (labelEl)    labelEl.hidden    = !showTimer;
    if (timerEl)    timerEl.hidden    = !showTimer;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    if (!endTime) return;
    var now = Date.now();
    var diff = endTime - now;
    if (diff <= 0) {
      pill.classList.add('nd-sale-pill--hidden');
      return;
    }
    // > 48h from end → show "ENDS SOON" instead of the live timer.
    if (diff > TIMER_THRESHOLD_MS) {
      setMode(false);
      return;
    }
    // ≤ 48h → show the live countdown (existing behavior).
    setMode(true);
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var dEl = pill.querySelector('[data-nd-pill-days]');
    var hEl = pill.querySelector('[data-nd-pill-hours]');
    var mEl = pill.querySelector('[data-nd-pill-mins]');
    var sEl = pill.querySelector('[data-nd-pill-secs]');
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  if (endTime) {
    // Tick every second (seconds now visible)
    setInterval(tick, 1000);
  }

  // Update % on variant change. Symmetry fires "on:variant:change" on the section.
  // Priority order for the displayed %:
  //   1) data-force-pct (block-level override, kept for backwards compat)
  //   2) variant's own compare_at_price vs price (Shopify-native discount)
  //   3) window.ndPromo.discountPercent (the shop-level active sale metafield)
  // Only HIDE the pill when none of these produce a positive %.
  function applyVariant(variant) {
    var pctEl = pill.querySelector('[data-nd-pill-pct]');
    var forced = Number(pill.getAttribute('data-force-pct') || 0);
    if (forced > 0) {
      if (pctEl) pctEl.textContent = forced + '%';
      pill.classList.remove('nd-sale-pill--hidden');
      return;
    }
    var resolved = 0;
    if (variant) {
      var price = Number(variant.price);
      var cap = Number(variant.compare_at_price);
      if (cap && cap > price && price > 0) {
        resolved = Math.round((cap - price) * 100 / cap);
      }
    }
    if (!resolved) {
      var meta = window.ndPromo || {};
      var metaPct = parseFloat(meta.discountPercent);
      if (!isNaN(metaPct) && metaPct > 0 && metaPct < 100) {
        resolved = Math.round(metaPct);
      }
    }
    if (resolved > 0) {
      if (pctEl) pctEl.textContent = resolved + '%';
      pill.classList.remove('nd-sale-pill--hidden');
    } else {
      pill.classList.add('nd-sale-pill--hidden');
    }
  }

  document.addEventListener('on:variant:change', function (e) {
    var v = (e && e.detail && e.detail.variant) || null;
    applyVariant(v);
  });
  // Some Symmetry builds dispatch on the section element; listen broadly
  document.body.addEventListener('on:variant:change', function (e) {
    var v = (e && e.detail && e.detail.variant) || null;
    applyVariant(v);
  });
})();
